import { BookingRestoreState } from './types'

export function decodeBookingState(encoded: string): BookingRestoreState | null {
  try {
    const json = atob(encoded)
    return JSON.parse(json) as BookingRestoreState
  } catch {
    return null
  }
}
